<!--
 * @Description: 总部署统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-17 17:59:26
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-24 10:26:27
 -->
<template>
  <div class="deployCount">
    <div class="regionItem" v-for="(item, index) in deployData.items" :key="index">
      <div>部署<span> {{item.projectCount}} </span>个</div>
      <div>使用<span> {{item.userCount}} </span>人</div>
      <div>{{item.region}}</div>
    </div>
    <div class="totalCount">
      <div>总部署<span> {{deployData.projectCount}} </span>个路段</div>
      <div>总使用<span> {{deployData.userCount}} </span>人</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deployCount',
  components: {
  },
  data () {
    return {
      deployData: {},
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/project/summary', {
        productCode: 'lcgl',
      })
        .then(res => {
          if (res.code === 0) {
            this.deployData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .deployCount {
    width: 100%;
    height: 100%;
    background: url('/static/img/layout/region.png');
    background-size: 100% 100%;
    position: relative;
    .regionItem {
      width: 25%;
      height: 20%;
      color: #fff;
      text-align: center;
      position: absolute;
      >div {
        font-size: 1.5vh;
        margin: 6%;
        >span {
          color: #fff32f;
          font-weight: bold;
        }
        &:nth-of-type(3) {
          color: #01ffff;
          font-size: 1.7vh;
          font-weight: bold;
          margin-top: 11%;
        }
      }
    }
    .regionItem:nth-of-type(1) {
      left: 4.2%;
      top: 23.5%;
    }
    .regionItem:nth-of-type(2) {
      left: 38%;
      top: 0;
    }
    .regionItem:nth-of-type(3) {
      left: 38.6%;
      top: 38%;
    }
    .regionItem:nth-of-type(4) {
      left: 72.3%;
      top: 28.7%;
    }
    .totalCount {
      width: 100%;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 12%;
      font-size: 1.5vh;
      color: #fff;
      >div{
        margin: 2%;
        >span {
          color: #fff32f;
          font-weight: bold;
        }
      }
    }
  }
</style>
